// Bloqueio de cliente potencial nas etapas do negócio (Orçamento, Financeiro e Validação).
// O tipo é lido no momento em que o utilizador finaliza a etapa, por isso o
// bloqueio desaparece assim que o cliente passa a final/habitual.
import axios from "axios";
import { toast } from "vue3-toastify";

const baseURl = process.env.VUE_APP_URL_BASE;

const normalizar = (valor) =>
  String(valor || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

// O negócio liga ao cliente através do local de instalação; consoante a origem
// do objeto pode já vir com o cliente resolvido.
export function getClienteIdFromNegocio(negocio) {
  return (
    negocio?.cliente?.id ||
    negocio?.localInstalacao?.cliente_id ||
    negocio?.local_instalacao?.cliente_id ||
    0
  );
}

// Devolve true quando o cliente ainda é potencial, ou seja, quando a etapa
// NAO deve avançar. Com mostrarToast=false o chamador mostra a mensagem
// (ex.: dentro de um popup, onde o toast fica por trás do overlay).
export async function bloqueiaPorClientePotencial(negocio, { mostrarToast = true } = {}) {
  const clienteId = getClienteIdFromNegocio(negocio);
  if (!clienteId) return false;

  try {
    const res = await axios.get(`${baseURl}/api/v1/cliente/${clienteId}/`);
    const tipo = res?.data?.data?.tipo?.nome;

    if (normalizar(tipo) !== "potencial") return false;

    if (mostrarToast) {
      toast(
        "Não é possível avançar de etapa: este é um cliente potencial. Transforme-o em cliente final ou habitual e adicione-o no Sage.",
        {
          theme: "auto",
          type: "warning",
          position: "top-center",
          autoClose: 8000,
        }
      );
    }
    return true;
  } catch (error) {
    console.error("Erro ao verificar o tipo de cliente:", error);
    return false;
  }
}
